import { Route, Routes } from 'react-router';
import './App.css';
import { HomePage } from './pages/home/HomePage';
import { Products } from './pages/products/Products';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<HomePage />} />
        <Route path='/products' element={<Products />} />
      </Routes>
    </div>
  );
}

export default App;
